/**
 * Native invariant implementation (replaces fbjs/lib/invariant dependency)
 *
 * Use invariant() to assert state which your program assumes to be true.
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were expecting.
 */
const invariant = (condition, format, ...args) => {
  if (!condition) {
    let error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
          'for the full error message and additional helpful warnings.'
      );
    } else {
      let argIndex = 0;
      error = new Error(format.replace(/%s/g, () => args[argIndex++]));
      error.name = 'Invariant Violation';
    }
    error.framesToPop = 1;
    throw error;
  }
};

export default invariant;
